import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import { ColorTag } from '@urbantxt/tag';
import { registerCellType } from '@urbantxt/table';
import { BagelDocumentStatus } from '../../../types';

const STATUS_COLOR: Record<
  BagelDocumentStatus,
  'green' | 'blue' | 'yellow' | 'red'
> = {
  ready: 'green',
  processing: 'blue',
  pending: 'yellow',
  error: 'red',
};

function BagelDocumentStatusCell({
  dataKey,
  rowData,
}: {
  dataKey: string;
  rowData: Record<string, unknown>;
}) {
  const status = rowData[dataKey] as BagelDocumentStatus;
  const errorMessage = rowData.errorMessage as string | undefined;
  const tag = <ColorTag color={STATUS_COLOR[status]}>{status}</ColorTag>;

  if (!errorMessage?.trim()) return tag;

  return (
    <Whisper
      placement="top"
      trigger="hover"
      speaker={
        <Tooltip style={{ maxWidth: 360, whiteSpace: 'pre-wrap' }}>
          {errorMessage}
        </Tooltip>
      }
    >
      <span style={{ display: 'inline-block' }}>{tag}</span>
    </Whisper>
  );
}

registerCellType('bagelDocumentStatus', BagelDocumentStatusCell);

export default BagelDocumentStatusCell;
